import { render } from "./Waterstation.vue?vue&type=template&id=3c9f8422&scoped=true&bindings={\"waterstation\":\"props\",\"active\":\"props\",\"checkBounds\":\"options\"}"
import script from "./Waterstation.vue?vue&type=script&lang=js"
export * from "./Waterstation.vue?vue&type=script&lang=js"

import "./Waterstation.vue?vue&type=style&index=0&id=3c9f8422&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c9f8422"

export default script